import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { FooterComponent } from "./footer/footer.component";
import { NavbarComponent } from "./navbar/navbar.component";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { ToggleFullscreenDirective } from "./directives/toggle-fullscreen.directive";
import { SharedCustomersComponentModule } from '@foh/shared/modules/shared-customers-component/shared-customers-component.module';
import { FormsModule } from '@angular/forms';
import { QueueHeaderComponent } from './queue-header/queue-header.component';



@NgModule({
    exports: [
        CommonModule,
        FooterComponent,
        NavbarComponent,
        SidebarComponent,
        ToggleFullscreenDirective,
        NgbModule,
        QueueHeaderComponent
    ],
    imports: [
        RouterModule,
        CommonModule,
        NgbModule,
        SharedCustomersComponentModule,
        FormsModule
    ],
    declarations: [
        FooterComponent,
        NavbarComponent,
        SidebarComponent,
        ToggleFullscreenDirective,
        QueueHeaderComponent
    ]
})
export class SharedModule { }
